import React, { useCallback, useEffect, useState } from "react";
import {
  ButtonPrimary,
  ButtonSecondary,
  Headline,
  Loading,
  SectionContent,
  Text,
} from "../../../../components";

const LoadingSamples = () => {
  const [loading, setLoading] = useState(false);

  const onLoadingHandle = useCallback((time) => {
    setLoading(true);
    return setTimeout(() => {
      setLoading(false);
    }, time || Math.floor((Math.random() * 100 + 1) * 100));
  }, []);

  useEffect(() => {
    const timeOut = onLoadingHandle(5 * 1000);
    return () => {
      clearTimeout(timeOut);
    };
  }, [onLoadingHandle]);

  return (
    <Loading loading={loading}>
      <SectionContent>
        <Headline nivel="2" styleAs="3" text="Loadings" />

        <Headline nivel="3" styleAs="6" text="Loading na seção" />
        <Text textSize="sm">Exemplo do loading sendo acionado via botão</Text>
        <ButtonPrimary
          label="loading na Seção"
          onClick={() => onLoadingHandle()}
        />
        <ButtonSecondary
          label="loading na Seção Infinito"
          onClick={() => onLoadingHandle(24 * 60 * 1000)}
        />
      </SectionContent>
    </Loading>
  );
};

LoadingSamples.propTypes = {};

export default LoadingSamples;
